<template>
  <div>
    <form>

      <div class="form-group" v-bind:class="{'has-error': fieldErrors('policyType')}">
        <label for="policyType">Policy Type</label>
        <select
          id="policyType"
          class="form-control"
          :value="policySpec.policyType"
          @input="updateFormField"
          name="policyType"
        >
          <option v-for="{id, label} in policyTypeOptions" v-bind:key="id" v-bind:value="id">
            {{ label }}
          </option>
        </select>
        <error-list v-bind:errors="fieldErrors('policyType')" />
      </div>

      <div v-show="isShortTermPolicy" class="form-group" :class="{'has-error' : fieldErrors('daysOfCoverage')}">
        <label for="daysOfCoverage">Days Of Coverage</label>
        <select @input="updateFormField" :value="policySpec.daysOfCoverage" name="daysOfCoverage" id="daysOfCoverage" class="form-control">
          <option
            v-for="n in shortTermDayOptions"
            :key="n"
            :value="n"
          >
            {{n}} Days
          </option>
        </select>
        <error-list v-bind:errors="fieldErrors('daysOfCoverage')" />
      </div>

      <div class="form-group" :class="{'has-error' : fieldErrors('coverageType')}">
        <label for="coverageType">Coverage Type</label>
        <select
          id="coverageType"
          class="form-control"
          @input="updateFormField"
          :value="policySpec.coverageType"
          :disabled="this.isDriversLicenseProduct"
          name="coverageType"
        >
          <option value="Liability">Liability</option>
          <option value="Full">Full</option>
        </select>
        <error-list v-bind:errors="fieldErrors('coverageType')" />
      </div>

      <div class="form-group" v-bind:class="{'has-error': fieldErrors('coverageArea')}">
        <label for="coverageArea">Coverage Area</label>
        <select @input="updateFormField" :value="policySpec.coverageArea" :disabled="this.isDriversLicenseProduct" name="coverageArea" id="coverageArea" class="form-control">
          <!-- values from CoverageArea.php -->
          <option value="0">Plan A - Limited Territory</option>
          <option value="1">Plan B - Full Territory</option>
          <option value="2">Baja Sonora</option>
        </select>
        <error-list v-bind:errors="fieldErrors('coverageArea')" />
      </div>

			<div class="form-group" v-bind:class="{'has-error': fieldErrors('datePolicyEffective')}">
        <label for="datePolicyEffective">Coverage Start Date</label>
        <input @input="updateFormField" :value="policySpec.datePolicyEffective" type="date" name="datePolicyEffective" id="datePolicyEffective" class="form-control" placeholder="mm/dd/yyyy">
        <error-list v-bind:errors="fieldErrors('datePolicyEffective')" />
      </div>

      <div class="form-group" :class="{'has-error': fieldErrors('timePolicyEffective')}">
        <label for="timePolicyEffective">Time Policy Effective/Expires</label>
        <select :value="policySpec.timePolicyEffective" @input="updateFormField" name="timePolicyEffective" id="timePolicyEffective" class="form-control">
          <!-- <option value="">-- Select Time --</option> -->
          <option value="0">12:00 Midnight PT</option>
          <option value="1">1:00 AM PT</option>
          <option value="2">2:00 AM PT</option>
          <option value="3">3:00 AM PT</option>
          <option value="4">4:00 AM PT</option>
          <option value="5">5:00 AM PT</option>
          <option value="6">6:00 AM PT</option>
          <option value="7">7:00 AM PT</option>
          <option value="8">8:00 AM PT</option>
          <option value="9">9:00 AM PT</option>
          <option value="10">10:00 AM PT</option>
          <option value="11">11:00 AM PT</option>
          <option value="12">12:00 Noon PM PT</option>
          <option value="13">1:00 PM PT</option>
          <option value="14">2:00 PM PT</option>
          <option value="15">3:00 PM PT</option>
          <option value="16">4:00 PM PT</option>
          <option value="17">5:00 PM PT</option>
          <option value="18">6:00 PM PT</option>
          <option value="19">7:00 PM PT</option>
          <option value="20">8:00 PM PT</option>
          <option value="21">9:00 PM PT</option>
          <option value="22">10:00 PM PT</option>
          <option value="23">11:00 PM PT</option>
        </select>
        <error-list v-bind:errors="fieldErrors('timePolicyEffective')" />
      </div>

    </form>

  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import ErrorList from "./ErrorList.vue"


export default {
  name: 'PolicySpecForm',
  components: {
    ErrorList,
  },
  props: [],
  created: function() {
    this.shortTermDayOptions = Array.from(Array(21).keys()).slice(1)
  },
  methods: {
    ...mapActions([
      'updateSpecField',
    ]),
    fieldErrors: function(fieldId) {
      let formErrors = this.policySpecErrors
      if (!formErrors) {
        return false;
      }
      if (!formErrors.hasOwnProperty(fieldId)) {
        return false
      }
      return formErrors[fieldId]
    },
    updateFormField: function(e) {
      let payload = {
        fieldkey: e.target.name,
        val: e.target.value,
      }
      this.updateSpecField(payload)
    },
  },
  computed: {
    ...mapState([
      'policySpec',
      'policySpecErrors',
      'policyTypeOptions',
    ]),
    ...mapGetters([
      'isShortTermPolicy',
      'isDriversLicenseProduct',
    ]),
  },
}
</script>

<style>
</style>
